<!-- BEGIN: Aside Menu -->
@if (isDesktop) {
  <div ktMenuAside (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)" id="kt_ver_menu"
    data-menu-vertical="true"
    [attr.kt-menu-dropdown-timeout]="500" [attr.kt-menu-scrollable]="ui.getIsMenuScrollable() ? 1 : 0"
    [attr.kt-menu-dropdown]="ui.getIsMenuScrollable() ? 0 : 1" [attr.aria-label]="l('LeftMenu')">
    <ul class="kt-menu__nav kt-menu__nav--dropdown-submenu-arrow">
      <div class="sidebar-title-box">
        <span class="sidebar-title">{{l(actualTopMenuItem.name) | uppercase}}</span>
      </div>
      <ng-container [ngTemplateOutlet]="ktMenuListing"></ng-container>
    </ul>
  </div>
}
<!-- END: Aside Menu -->
<!-- </div> -->
<ng-template #ktMenuListing>
  @for (child of actualTopMenuItem.items; track child) {
    @if (showMenuItem(child)) {
      <ng-container [ngTemplateOutlet]="ktMenuItem"
      [ngTemplateOutletContext]="{ item: child, parentItem: actualTopMenuItem }"></ng-container>
    }
  }
</ng-template>

<ng-template #ktMenuItem let-item="item" let-parentItem="parentItem">
  @if (showMenuItem(item)) {
    <li class="{{ui.getSideBarMenuItemClass(item, isMenuItemIsActive(item))}}"
      kt-menu-submenu-toggle="hover">
      <!-- if menu item hasn't submenu -->
      @if (!item.items.length && !item.external) {
        <a [queryParams]="item.parameters" [routerLink]="item.route"
          class="kt-menu__link kt-menu__toggle d-flex flex-row align-items-center">
          <ng-container [ngTemplateOutlet]="ktMenuItemText"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>
      }
      @if (!item.items.length && item.external) {
        <a [attr.href]="item.route" target="_blank"
          class="kt-menu__link kt-menu__toggle d-flex flex-row align-items-center">
          <ng-container [ngTemplateOutlet]="ktMenuItemText"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>
      }
      <!-- if menu item has submenu child  -->
      @if (item.items.length) {
        <a href="javascript:;"
          class="kt-menu__link kt-menu__toggle d-flex flex-row align-items-center">
          <ng-container [ngTemplateOutlet]="ktMenuItemText"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>
      }
      <!-- if menu item has submenu child then recursively call new menu item component -->
      @if (item.items.length) {
        <div class="kt-menu__submenu">
          <span class="kt-menu__arrow"></span>
          <ul class="kt-menu__subnav">
            @for (child of item.items; track child) {
              <ng-container [ngTemplateOutlet]="ktMenuItem"
              [ngTemplateOutletContext]="{ item: child, parentItem: item }"></ng-container>
            }
          </ul>
        </div>
      }
    </li>
  }
</ng-template>

<ng-template #ktMenuItemText let-item="item" let-parentItem="parentItem">
  <span class="kt-menu__item-here"></span>
  <!-- if menu item has icon -->
  @if (item.icon) {
    <img class="kt-menu__link-icon mr-15" src="/assets/common/images/sidebar-icons/{{item.icon}}" alt="{{ item.name | localize }}" />
  }

  <!-- if menu item using bullet -->
  @if (parentItem && parentItem.bullet === 'dot') {
    <i class="kt-menu__link-bullet kt-menu__link-bullet--dot">
      <span></span>
    </i>
  }
  @if (parentItem && parentItem.bullet === 'line') {
    <i class="kt-menu__link-bullet kt-menu__link-bullet--line">
      <span></span>
    </i>
  }

  @if (!item.badge) {
    <!-- menu item title text -->
    <span class="kt-menu__link-text">
      {{item.name | localize}}
    </span>
  } @else {
    <!-- menu item with badge -->
    <span class="kt-menu__link-title">
      <span class="kt-menu__link-wrap">
        <span class="kt-menu__link-text">
          {{item.name | localize}}
        </span>
        <span class="kt-menu__link-badge">
          <span class="kt-badge" [ngClass]="item.badge.type">{{item.badge.value}}</span>
        </span>
      </span>
    </span>
  }


  <!-- if menu item has submenu child then put arrow icon -->
  @if (item.items.length) {
    <i class="kt-menu__ver-arrow la la-angle-right"></i>
  }
</ng-template>
<!-- END: Left Aside -->
